<div *ngIf="html" [@fade]="animationState" (@fade.done)="onAnimationEnd($event)" [@.disabled]="!animation"
  [innerHTML]="title" class="tooltip-inner" [class]="colorClass">
</div>
<div *ngIf="!html" [@fade]="animationState" (@fade.done)="onAnimationEnd($event)" [@.disabled]="!animation"
  class="tooltip-inner" [class]="colorClass"> {{ title }}</div>
